import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Login from "./Auth/Login";

const LoginRedirect: React.FC = () => {
  const { userRole } = useAuth();

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
  }, []);

  if (userRole === "Admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (userRole === "Artist") {
    return <Navigate to="/artist/dashboard" replace />;
  }
  return <Login />;
};

export default LoginRedirect;
